export const BASE_URL = 'https://agent.goldtreeastro.com';
export const API_URL = 'https://api.goldtreeastro.com';

export const LOGOUT_URL = API_URL + '/logout';
export const USER_DETAILS_URL = API_URL + '/user-details';
export const CALL_REQUEST_URL = API_URL + '/agents/urequests';
export const CALL_URL = API_URL + '/agentCall';
export const REMEDY_URL = API_URL + '/remedy-lists';
export const REMEDY_RESPONSE_URL = API_URL + '/remedy-responses';

export const REQUEST_URL_WITH_ID = (id) => {
    return `${API_URL}/urequests/${id}`;
}

export const REQUEST_HISTORY_URL = (id) => {
    return `${API_URL}/urequests/${id}/call-histories`;
}

export const REQUEST_FEEDBACK_URL = (id) => {
    return `${API_URL}/urequests/${id}/feedbacks`;
}

export const REQUEST_REMEDIES_URL = (id) => {
    return `${API_URL}/urequests/${id}/remedies`;
}

export const REQUEST_BACKUP_URL = (id) => {
    return `${API_URL}/urequests/${id}/backups`;
}

export const FLAG_URL = (id) => {
    return `${API_URL}/agentsFlag/${id}`;
}

export const DEFLAG_URL = (id) => {
    return `${API_URL}/agentsDeflag/${id}`;
}